module.exports = __webpack_public_path__ + "img/auth-back.28d4a9e4.jpg";